/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';
import { PipesModule } from 'app/common/pipes/pipes.module';

import { FileQuotaTableComponent } from './file-quota-table/file-quota-table.component';
import { FileShareTableComponent } from './file-share-table/file-share-table.component';
import { MappingLunLinkComponent } from './mapping-table/mapping-lun-link/mapping-lun-link.component';
import { MappingMemberLunComponent } from './mapping-table/mapping-member-lun/mapping-member-lun.component';
import { MappingTableComponent } from './mapping-table/mapping-table.component';
import { MemberDtreeTableComponent } from './member-dtree-table/member-dtree-table.component';
import { MemberHostTableComponent } from './member-host-table/member-host-table.component';
import { MemberInitiatorsTableComponent } from './member-initiators-table/member-initiators-table.component';
import { MemberLunTableComponent } from './member-lun-table/member-lun-table.component';
import { MemberPortTableComponent } from './member-port-table/member-port-table.component';

@NgModule({
    declarations: [
        MappingTableComponent,
        MemberLunTableComponent,
        MemberInitiatorsTableComponent,
        MappingMemberLunComponent,
        MemberHostTableComponent,
        MemberPortTableComponent,
        FileShareTableComponent,
        FileQuotaTableComponent,
        MemberDtreeTableComponent,
        MappingLunLinkComponent,
    ],
    imports: [
        CommonModule,
        CoreModule,
        PipesModule,
    ],
    exports: [
        MappingTableComponent,
        MemberLunTableComponent,
        MemberInitiatorsTableComponent,
        MappingMemberLunComponent,
        MemberHostTableComponent,
        MemberPortTableComponent,
        FileShareTableComponent,
        FileQuotaTableComponent,
        MemberDtreeTableComponent,
    ],
})
export class ResourceTableModule {
}
